// extracted by mini-css-extract-plugin
module.exports = {"table":"index_table_2--yf","custom-image-video":"index_custom-image-video_1UVK-","custom-modal-image-video":"index_custom-modal-image-video_su99B"};